import { useEffect } from 'react';

import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import type {
  WeeklyStreaks_QueryWeeklyStreaksQuery as QueryWeeklyStreaks,
  WeeklyStreaks_QueryWeeklyStreaksQueryVariables as QueryWeeklyStreaksQueryVariables,
} from 'bundles/daily-goals/__queries__/__generated__/queryWeeklyStreaks';
import queryWeeklyStreaks from 'bundles/daily-goals/__queries__/queryWeeklyStreaks.graphql';
import { areWeeklyStreaksEnabled } from 'bundles/goal-setting/components/unified-goals/utils/featureGates';

const useQueryWeeklyStreaks = () => {
  const { data, loading, error } = useQuery<QueryWeeklyStreaks, QueryWeeklyStreaksQueryVariables>(queryWeeklyStreaks, {
    // Ensure we never run this query if the feature flag is disabled
    skip: !areWeeklyStreaksEnabled(),
    context: { clientName: 'gatewayGql' },
  });

  useEffect(() => {
    if (error) {
      Sentry.captureException(error, {
        extra: {
          message: 'Weekly Streaks: Error fetching weekly streaks',
        },
      });
    }
  }, [error]);

  const weeklyStreak = data?.LearnerStreaks?.queryWeeklyStreak;
  return { weeklyStreak, loading, error };
};

export default useQueryWeeklyStreaks;
